/**
 * Calculates the power based on the selected number.
 * The power is calculated using a formula with coefficients a, b, c and d.
 * 	//returns power * 0.1; // using formualar a + b * lum + c * lum ^ 2 + d * lum ^ 3
 *
 * @param {number} lum - The selected number from the slider, used as an input for the power calculation.
 * @param {array} coefficients - coefficients for the formular
 * @return {number} - The calculated power value, rounded to the nearest integer.
 */
export function calculatePower(lum, coefficients) {
	// TODO: use formular type
	// console.log('calculatePower', lum, coefficients);
	const c = coefficients;
	const power = c[0] +  c[1] * lum + c[2] * Math.pow(lum, 2) + c[3] * Math.pow(lum, 3);
	return Math.round(power * 1)/1;
}
/**
 * Calculates the power based on the selected number.
 * The power is calculated using a formula with coefficients a, b, c and d.
 * 	//returns power * 0.1; // using formualar a + b * lum + c * lum ^ 2 + d * lum ^ 3
 *
 * @param {number} lum - The selected number from the slider, used as an input for the power calculation.
 * @param {array} coefficients - coefficients for the formular
 * @return {number} - The calculated current value, rounded to the nearest integer.
 */
export function calculateCurrent(lum, coefficients) {
	// TODO: use formular type
	const c = coefficients;
	const power = c[0] +  c[1] * lum + c[2] * Math.pow(lum, 2) + c[3] * Math.pow(lum, 3);

	// round power to multiples of 12.5
	return Math.round(Math.round(power / 12.5)*12.5);
}
